import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { BenefitsBento } from "@/components/BenefitsBento";
import { SafeSpendSimulator } from "@/components/SafeSpendSimulator";
import { SocialProofSection } from "@/components/SocialProofSection";
import { RatingGuideSection } from "@/components/RatingGuideSection";
import { FooterSection } from "@/components/FooterSection";
import { StickyMobileCta } from "@/components/StickyMobileCta";

export default function PaymentPulseLanding() {
  return (
    <div id="top" data-testid="payment-pulse-landing" className="min-h-screen bg-[#070C18] text-white">
      <Navbar />
      <main>
        <HeroSection />
        <BenefitsBento />
        <SafeSpendSimulator />
        <SocialProofSection />
        <RatingGuideSection />
      </main>
      <FooterSection />
      <StickyMobileCta />
    </div>
  );
}
